import FamilyModelCommon from 'common/models/family';

export default class FamilyModel extends FamilyModelCommon {}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    family: FamilyModel;
  }
}
